module.exports = __webpack_public_path__ + "03_mustache_silver.4d72820d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/03_mustache_silver.png
// module id = kE+L
// module chunks = 0